import React, { useRef } from 'react';
import {
  IInfrastructureTypeIframe,
} from 'src/components/ApartmentPageV2/ViewSpinner/components/RenderSvg/components/InfrastructureType/types';
import { useStyles } from 'src/components/ViewSpinner/components/RenderSvg/components/InfrastructureType/styles';
import {
  useFullScreenMode,
} from 'src/components/ViewSpinner/components/RenderSvg/components/InfrastructureType/components/InfrastructurePanorama/use-fullscreen-mode';
import { AppGallery } from 'src/components/AppGallery';
import { ButtonApp } from 'src/components/Button';
import { resizeEmulate } from 'src/helpers';
import { SvgFullScreenOut } from 'src/components/ApartmentPageV2/LayoutApartmentItem/components/SvgFullScreenOut';
import { SvgFullScreen } from 'src/components/ApartmentPageV2/LayoutApartmentItem/components/SvgFullScreen';
import { SvgClose } from 'src/components/ApartmentPageV2/LayoutApartmentItem/components/SvgClose';
import { useIsMobile } from 'src/hooks';

export const InfrastructureIframe: React.FC<IInfrastructureTypeIframe> = ({ data, close }) => {
  const refAppGallery = useRef();
  const styles = useStyles({});
  const {
    isFullScreen,
    handleFullScreen,
  } = useFullScreenMode(refAppGallery);
  const { isMobileScreen } = useIsMobile();

  const _renderItem = () => {
    return (
      <iframe
        className="panorama-iframe"
        allowFullScreen
        frameBorder={0}
        title="panorama"
        src={data['infrastructure.src']}
        width="100%"
        height="100%"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      />
    );
  };

  return (
    <div className={styles.wrapperInfrastructureType}>
      <AppGallery
        ref={refAppGallery}
        lazyLoad
        showFullscreenButton={!isMobileScreen}
        disableSwipe
        additionalClass={`${styles.appPanoramaWrapper}`}
        showBullets={false}
        showPlayButton={false}
        showNav={false}
        showThumbnails={false}
        items={[{
          original: '',
          thumbnail: '',
          originalClass: isMobileScreen ? 'apartment-gallery-slide-iframe-mobile' : !isFullScreen ? 'apartment-gallery-slide-iframe' : '',
          thumbnailClass: 'apartment-gallery-thumbnail',
        }]}
        onScreenChange={() => handleFullScreen()}
        renderCustomControls={() => {
          return (
            <>
              {isMobileScreen && (
                <div className={styles.headerIframeMobile}>
                  <div className={styles.headerIframeMobileTitle}>{data['infrastructure.head_text']}</div>
                  <ButtonApp
                    className={`${styles.zoomButtonIframe} ${styles.zoomButtonIframeMobile}`}
                    onClick={() => {
                      close();
                    }}
                  >
                    <SvgClose />
                  </ButtonApp>
                </div>
              ) }
            </>
          );
        }}
        renderFullscreenButton={(onClick, isFullscreen) => {
          return (
            <>
              <ButtonApp
                className={`${styles.zoomButtonIframe}`}
                onClick={(event) => {
                  onClick(event);
                  setTimeout(resizeEmulate, 250);
                }}
              >
                {
                  isFullscreen
                    ? <SvgFullScreenOut />
                    : <SvgFullScreen />
                }
              </ButtonApp>
            </>
          );
        }}
        renderItem={_renderItem}
        renderThumbInner={() => null}
      />
    </div>
  );
};
